import lottie from 'lottie-web';

export class Lottie {

    constructor() {
        this.lottie = lottie;
    }

    init() {
        this.lottie.loadAnimation({
            container: document.getElementById('camp'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/assets/00-camp-t-shirt-fire-animation.json',
            rendererSettings: {
                viewBoxOnly: true,
                className: 'c-banner__camp-src',
            },
            progressiveLoad: true,
        });
    }
}
